import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from './crud.service';

export interface IAvailableCountry {
	countryCode: string;
	name: string;
}

export interface IBaseCalendar {
	alias: string;
	description: string; // This property is not implemented
}

export interface ICalendar extends IBaseCalendar {
	id: string;
}

export interface ICalendars {
	result: ICalendar[];
}

export interface IRequestCalendar extends IBaseCalendar {
	// No additional properties
}

export interface IResponseCalendar extends IBaseCalendar {
	statusCode: number;
	result: ICalendar;
}

export interface ICalendarYear {
	year: number;
	holidayCalendar: string;
	workTaskId: string;
	calendarId: string;
}

export interface ICalendarDay {
	date: Date;
	appointmentTypes: string;
	title: string;
}

export interface ICalendarDayAppointment {
	id: string;
	date: Date;
	title: string;
	appointmentType: string;
}

@Injectable({
	providedIn: 'root',
})
export class CalendarService {
	constructor(
		private http: HttpClient,
		private crudService: CrudService,
	) {}

	getHolidayCalendars(): Observable<IAvailableCountry[]> {
		return this.http.get<IAvailableCountry[]>('https://date.nager.at/api/v3/AvailableCountries');
	}

	createCalendar(calendar: ICalendar): Observable<IRequestCalendar> {
		const request: IRequestCalendar = {
			alias: calendar.alias,
			description: '',
		};
		return this.crudService.create<IRequestCalendar, IResponseCalendar>(request, '/mes/calendars');
	}

	getCalendars(): Observable<ICalendars> {
		return this.crudService.get<ICalendars>('/mes/calendars');
	}

	deleteCalendarById(calendarId: string): Observable<any> {
		return this.crudService.delete(`/mes/calendars/${calendarId}`);
	}

	createHolidays(yearData: ICalendarYear) {
		const body: ICalendarYear = {
			year: yearData.year,
			holidayCalendar: yearData.holidayCalendar,
			workTaskId: yearData.workTaskId,
			calendarId: yearData.calendarId,
		};
		return this.crudService.create<ICalendarYear, void>(body, `/mes/calendars/${yearData.calendarId}/holidays`);
	}
}
